import { identity } from "lodash";
import { FC } from "react";
import { Field } from "react-final-form";
import { Descendant } from "slate";

import { FormField } from "@livechat/design-system-react-components";

import { FormattedTextEditor } from "components/rich-editor/formatted-text-editor";

type Props = {
  name: string;
};

export const ParagraphBlock: FC<Props> = ({ name }) => {
  return (
    <FormField labelText="Description" css={{ display: "flex", flexDirection: "column" }}>
      <Field<Descendant[]>
        keepState
        parse={identity}
        name={`${name}.value.html`}
        render={FormattedTextEditor}
        linksPlugin
        richTextPlugin
        withBold
        withItalic
        withUnderline
        withStrikethrough
        richTextAreaMinHeight="unset"
      />
    </FormField>
  );
};
